import { useCallback } from "react";

import { useAppDispatch } from "../Store/Hooks";
import { logout, logoutUser } from "../Store/Reducers/AuthSlice";
import { clearLocalSessionState } from "../Utils/Helper/sessionCleanup";

type UseLogoutOptions = {
  redirectToLogin?: boolean;
  onComplete?: () => void;
};

/**
 * Full client logout: API revoke + cookies (via API) + Redux + storage + PostHog.
 */
export function useLogout(options: UseLogoutOptions = {}) {
  const { redirectToLogin = true, onComplete } = options;
  const dispatch = useAppDispatch();

  const logoutSession = useCallback(async () => {
    try {
      await dispatch(logoutUser() as any).unwrap();
    } catch (error) {
      console.error("Logout API error:", error);
    } finally {
      dispatch(logout());
      clearLocalSessionState();
      onComplete?.();
      if (redirectToLogin) {
        window.location.href = "/login";
      }
    }
  }, [dispatch, onComplete, redirectToLogin]);

  return logoutSession;
}
